;
define("cart_promocode_list.tpl", function(){});

